import React, { Component } from 'react';
import Lines from '../AboutDir/Lines';
import ProjectCards from './ProjectCards';
import 'bootstrap/dist/css/bootstrap.min.css';
// import 'tachyons';
import './Portfolio.css';

class Project extends Component {
    render() {
        return (
            <div className="mt-5 portfolio">
                <h1 className="f2 fw5 black-80 athelas tc ttu mb-5">
                    MY RECENT WORKS
                    <div style={{ marginTop: "-20px" }}><Lines /></div>
                </h1>
                <ProjectCards />
            </div>
        )
    }
}

export default Project;
